import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { PaginatedResponse } from '@/modules/core/app/models/PaginatedResponse';
import { BaseResourceService } from '@/modules/core/app/services/abstracts/BaseResourceService';

export abstract class BaseEntityService<T extends BaseEntityModel> extends BaseResourceService {
  async getEntities(params: Params = {}): Promise<T[]> {
    params = this.addParams(params ?? {});
    return this.resource.getItems(params);
  }

  async getPaginatedEntities(params: Params = {}): Promise<PaginatedResponse<T>> {
    params = this.addParams(params ?? {});

    return new PaginatedResponse<T>((await this.resource.getItems(params)) ?? {});
  }

  async getEntity(id: number | string, params: Params = {}): Promise<T> {
    params = this.addParams(params ?? {});
    return this.resource.getItem(id, params);
  }

  async getTotal(params: Params = {}): Promise<number> {
    params = this.addParams(params ?? {});
    return this.resource.getTotal(params);
  }

  async copyEntity(id: number): Promise<T[]> {
    return this.resource.copyItem(id);
  }

  async deleteEntity(id: number | string): Promise<T[]> {
    return this.resource.deleteItem(id);
  }

  async saveEntity(data: T, id?: number | undefined): Promise<T> {
    return this.resource.saveItem(data, id);
  }

  addParams(params: Params = {}): Params {
    return params;
  }
}
